/**
 * 密码强度规则
 * 根据参数 chrtype 动态生成校验规则
 *
 * chrtype 说明：
 *   0 - 任意字符（默认）
 *   1 - 纯数字（0-9）
 *   2 - 纯字母（a-z / A-Z）
 *   3 - 字母 + 数字（必须同时包含）
 *   4 - 字母 + 数字 + 特殊字符（必须同时包含，特殊字符：~!@#$%^&*()-=_+）
 */
// 各类型对应的正则、错误提示
const PWD_RULES = {
  '0': { pattern: /^[^<>"'|\\]+$/, message: '密码不能包含非法字符：< > " \' \\ |' },
  '1': { pattern: /^[0-9]+$/, message: '密码只能为数字（0-9）' },
  '2': { pattern: /^[a-zA-Z]+$/, message: '密码只能为英文字母（a-z、A-Z）' },
  '3': { pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/, message: '密码必须同时包含字母和数字' },
  '4': { pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()\-=_+])[A-Za-z\d~!@#$%^&*()\-=_+]+$/, message: '密码必须同时包含字母、数字和特殊字符（~!@#$%^&*()-=_+）' }
}

export default {
  data() {
    return {
      // 密码限制类型
      pwdChrType: this.$store.getters.pwdChrtype || '0'
    }
  },
  methods: {
    /**
     * 通用密码校验方法
     * @param {String} password - 需要校验的密码字符串
     * @returns {Boolean} - 校验通过返回 true，失败返回 false
     */
    validatePassword(password) {
      // 1. 基础非空校验
      if (!password || password.trim() === '') {
        this.$toast({ type: 'error', message: '密码不能为空' });
        return false;
      }

      // 2. 长度校验 (6-20位)
      if (password.length < 6 || password.length > 20) {
        this.$toast({ type: 'error', message: '密码长度必须介于 6 和 20 之间' });
        return false;
      }

      // 3. 获取当前类型的规则
      const rule = PWD_RULES[this.pwdChrType] || PWD_RULES['0'];

      // 4. 正则校验
      if (!rule.pattern.test(password)) {
        this.$toast({ type: 'error', message: rule.message });
        return false;
      }

      // 全部通过
      return true;
    }
  }
}
